
/* injects from baggage-loader */

'use strict';

import BookmarksController from './bookmarks.controller';
import BookmarksTemplate from './bookmarks.html';

export default class BookmarksComponent {
		constructor() {
				this.templateUrl = BookmarksTemplate;
				this.controller = BookmarksController;
				this.controllerAs = 'ctrl';
				// Bind resolved items to the controller, see module state for resolve
				// this.bindings = { };
		}
}



// WEBPACK FOOTER //
// ./src/app/pages/bookmarks/bookmarks.component.js